module.exports = __webpack_public_path__ + "static/media/elipsis-vertical.96ecc10c.svg";